import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  list: []
}

// getters
export const getters = {
  list: state => state.list
}

// mutations
export const mutations = {
  LIST (state, data) {
    state.list = data
  }
}

// actions
export const actions = {
  async fetchLocationsList ({ commit }) {
    const { data } = await axios.get(laroute.route('app_company_stock_location_list', {
      companyAbbr: store.getters['auth/company']
    }))
    commit('LIST', data)
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stockLocation.js